import { twMerge } from 'tailwind-merge';

import { getBadgeBackground } from '@ui/components/organisms/badge/badge.utils';
import { IBadgeClaimCreators, IBadgeClaimType } from '../../badge-claim.typings';
import { badgeClaimClassName } from '../../badge-claim.style';
import { Avatar, Button, Icon } from '@ui/components/atoms';
import { IBadgeClaimUser } from '../../badge-claim.typings';
import korcrewLogo from '@ui/assets/images/Logo-text-dark.png';
import { useRouter, useSearchParams } from 'next/navigation';
import Link from 'next/link';
import { IWhitelabelConfig } from '../../../user/creator-details.typings';
import { getLabel } from '../../../../../lib/labels';
import { DynamicRouteBuilder } from '@ui/constants';

interface IBadgeClaimInfoLayout {
  claimType: IBadgeClaimType;
  color: string;
  children: React.ReactNode;
  user: IBadgeClaimUser;
  onBack?(): void;
  creator?: IBadgeClaimCreators;
  whitelabelConfig?: IWhitelabelConfig;
}

export function BadgeClaimInfoLayout({
  children,
  claimType,
  color,
  user,
  onBack,
  creator,
  whitelabelConfig,
}: IBadgeClaimInfoLayout) {
  const background = getBadgeBackground(color);
  const params = useSearchParams();
  const isFromClaim = params.get('claim');
  const router = useRouter();

  const handleBadgeClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    if (isFromClaim) {
      creator?.creator_id && router.push(DynamicRouteBuilder.badges(creator?.name));
    }
  };

  const className = badgeClaimClassName[claimType];
  return (
    <div
      style={{ backgroundColor: background }}
      className={twMerge('lg:w-1/2', className.container.badge)}>
      <div
        className={twMerge(
          `flex h-full flex-col bg-white lg:basis-1/2 lg:bg-transparent lg:px-10`,
          className.container.badgeInternal,
        )}>
        <div
          className={twMerge(
            'hidden items-center justify-between py-10 lg:flex',
            className.badgeDetails.background,
          )}>
          {isFromClaim ? (
            <div
              className="text-sm underline text-primary cursor-pointer"
              onClick={handleBadgeClick}>
              My Badges
            </div>
          ) : (
            <Button
              type="secondary"
              className="h-12 w-12 min-w-0 rounded-full p-0"
              onClick={onBack}>
              <Icon type="backArrow" />
            </Button>
          )}

          <img src={korcrewLogo.src} alt="Korcrew" className="w-[150px]" />
          <div
            className={
              user.name
                ? 'flex items-center gap-2 overflow-hidden rounded-full p-2 font-medium bg-input hover:bg-inputActive active:bg-inputActive'
                : ''
            }>
            {user?.name && (
              <Link href="/settings">
                <Avatar
                  size="sm"
                  src={user.avatar}
                  className={user.showAvatar ? '' : 'invisible'}
                  isSubscribed={user?.isSubscribed}
                  displayName={user.name}
                />
              </Link>
            )}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
